export default __webpack_public_path__ + "static/media/g.bee05950.png";